// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__xFRWD","dragIcon":"SortableItem_dragIcon__3E966","disabled":"SortableItem_disabled__3ykp_"};